module.exports = __webpack_public_path__ + "img/accountantGreen.71835887.png";